import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { PAYPAL_THEME } from './theme.css';
export * from './theme.css';
export * from './themeContract.css';
export * from './darkTheme.css';

var _excluded = ["theme", "className", "children"];
var ThemeWrapper = function (_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? PAYPAL_THEME : _ref$theme,
    className = _ref.className,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "ppui-theme ".concat(theme, " ").concat(className ? className : '')
  }, rest), children);
};

var breakpoints = {
  mediaXs: '22rem',
  mediaSm: '36rem',
  mediaMd: '47rem',
  mediaLg: '64rem',
  mediaXl: '72rem',
  mediaXxl: '90rem'
};

export { ThemeWrapper, breakpoints };
